/* src/app/components/ads-subscription-modal/ads-subscription-modal.component.scss */
.header,
.header > div {
  gap: 15px;
}
.header ion-icon {
  width: 30px;
  height: 30px;
}
.header h1 {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
ion-button {
  margin: 0;
  min-height: 0;
}
ion-button > ion-icon {
  width: 24px !important;
  height: 24px !important;
  color: black;
}
ion-button.close {
  --border-radius: 0px;
}
ion-button.close::part(native) {
  padding: 0;
}
h2 {
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.message {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.buttons > button {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  border-radius: 15px;
  padding: 14px 18px;
  transition: opacity 100ms linear ease-in;
  outline: none;
}
.buttons > button:last-of-type {
  color: white;
  background-color: #f5b200;
}
.buttons > button:last-of-type:hover {
  opacity: 0.9;
}
.buttons > button:last-of-type:active {
  background-color: #f0b003;
  opacity: 1;
}
.buttons > button.subscribe {
  background-color: #43c0f6;
}
.buttons > button.subscribe:active {
  background-color: #3eb8ec;
  opacity: 1;
}
/*# sourceMappingURL=ads-subscription-modal.component-MF3JM4XR.css.map */
